module.exports = __webpack_public_path__ + "static/media/YB5M14_4.77c448ed.jpg";